import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntryControlComponent } from './entry-control.component';
import { StoreComponent } from './store/store.component';
import { AddStoreComponent } from './store/add-store/add-store.component';
import { EditStoreComponent } from './store/edit-store/edit-store.component';
import { NgbModule, NgbPagination, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImageDefaultConfig, ImageDefaultModule } from 'src/app/directives/image-default/image-default.module';
import { EntryControlRoutingModule } from './entry-control-routing.module';
import { ListStoreComponent } from './store/list-store/list-store.component';
import { AddEmployeesComponent } from './store/employees/add-employees/add-employees.component';
import { EditEmployeesComponent } from './store/employees/edit-employees/edit-employees.component';
import { InputPasswordGenerateComponent } from 'src/app/components/standalone/input-password-generate/input-password-generate.component';
import { WarningInputFormsComponent } from 'src/app/components/standalone/warning-input-forms/warning-input-forms.component';
import { ListEmployeesComponent } from './store/employees/list-employees/list-employees.component';
import { AddProvidersComponent } from './store/providers/add-providers/add-providers.component';
import { EditProvidersComponent } from './store/providers/edit-providers/edit-providers.component';
import { ListProvidersComponent } from './store/providers/list-providers/list-providers.component';
import { AddFacilityComponent } from './facility/add-facility/add-facility.component';
import { EditFacilityComponent } from './facility/edit-facility/edit-facility.component';
import { ListUsersComponent } from './store/users/list-users/list-users.component';
import { AddUsersComponent } from './store/users/add-users/add-users.component';
import { EditUsersComponent } from './store/users/edit-users/edit-users.component';
import { EditVisitorComponent } from './store/visitors/edit-visitor/edit-visitor.component';
import { AddVisitorComponent } from './store/visitors/add-visitor/add-visitor.component';
import { ListVisitorComponent } from './store/visitors/list-visitor/list-visitor.component';
import { RecordsComponent } from './records/records.component';
import { ListGuardComponent } from './records/guards/list-guard/list-guard.component';
import { AddGuardComponent } from './records/guards/add-guard/add-guard.component';
import { EditGuardComponent } from './records/guards/edit-guard/edit-guard.component';
import { ListDevicesComponent } from './records/devices/list-devices/list-devices.component';
import { EditDevicesComponent } from './records/devices/edit-devices/edit-devices.component';
import { AddDevicesComponent } from './records/devices/add-devices/add-devices.component';
import { ListRecordsComponent } from './records/list-records/list-records.component';

import { SearchRecordComponent } from './records/search-record/search-record.component';
import { AdminStoreComponent } from './store/admin-store/admin-store.component';
import { AdminRecordsComponent } from './store/admin-records/admin-records.component';
import { UploadFileModule } from '../common/upload-file/upload-file.module';
import { ListFacilityComponent } from './facility/list-facility/list-facility.component';
import { ListRecorsFacilityComponent } from './records/list-records-facility/list-recors-facility.component';
import { ListStoresFacilityComponent } from './facility/list-stores/list-stores-facility.component';
import { ListFacilitySupervisorComponent } from './facility/list-facility-supervisor/list-facility-supervisor.component';
import { ViewFacilityComponent } from './facility/view-facility/view-facility.component';
import { ListControlsComponent } from './records/list-records/list-controls/list-controls.component';
import { ListRoundsComponent } from './records/list-records/list-rounds/list-rounds.component';
import { ListTagsComponent } from './records/devices/tags/list-tags/list-tags.component';
import { EditTagsComponent } from './records/devices/tags/edit-tags/edit-tags.component';
import { AddTagsComponent } from './records/devices/tags/add-tags/add-tags.component';
import { ListPhonesComponent } from './records/devices/phones/list-phones/list-phones.component';
import { ListScheduledRoundsComponent } from './facility/rounds/scheduled-rounds/list-scheduled-rounds/list-scheduled-rounds.component';
import { AddScheduledRoundsComponent } from './facility/rounds/scheduled-rounds/add-scheduled-rounds/add-scheduled-rounds.component';
import { EditScheduledRoundsComponent } from './facility/rounds/scheduled-rounds/edit-scheduled-rounds/edit-scheduled-rounds.component';
import { ListRoundsFacilityComponent } from './records/list-records-facility/list-rounds-facility/list-rounds-facility.component';
import { ListControlsFacilityComponent } from './records/list-records-facility/list-controls-facility/list-controls-facility.component';
import { MatInputModule } from '@angular/material/input';
import { DndModule } from 'ngx-drag-drop';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RepositoryImageModule } from '../common/repository-image/repository-image.module';
import { DropTagsComponent } from './facility/rounds/drop-tags/drop-tags.component';
import { TrafficLightComponent } from 'src/app/components/standalone/traffic-light/traffic-light.component';
import { AdminRoundsComponent } from "./store/admin-rounds/admin-rounds.component";
import { ListCarsComponent } from './store/cars/list-cars/list-cars.component';
import { EditCarComponent } from './store/cars/edit-car/edit-car.component';
import { AddCarComponent } from './store/cars/add-car/add-car.component';
import { SuggestionInputComponent } from 'src/app/components/suggestion-input/suggestion-input.component';
import { AddDriverComponent } from './store/cars/drivers/add-driver/add-driver.component';
import { EditDriverComponent } from './store/cars/drivers/edit-driver/edit-driver.component';
import { ListDriversComponent } from './store/cars/drivers/list-drivers/list-drivers.component';
import { ExcelComponent } from './reports/excel/excel.component';
import { InputTextCompleteComponent } from "../../components/standalone/input-text-complete/input-text-complete.component";
import { ToolbarSearchComponent } from "../../components/standalone/toolbar-search/toolbar-search.component";
import { BackButtonComponent } from "../../components/standalone/back-button/back-button.component";
import { InformationPanelComponent } from "./store/information-panel/information-panel.component";
import { EditorHtmlModule } from '../common/editor-html/editor-html.module';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ListTasksFacilityComponent } from './facility/tasks/list-tasks-facility/list-tasks-facility.component';
import { AddTaskChecklistComponent } from './facility/tasks/add-task-checklist/add-task-checklist.component';
import { EditTaskChecklistComponent } from './facility/tasks/edit-task-checklist/edit-task-checklist.component';
import { ViewTaskExecutionComponent } from './facility/tasks/view-task-execution/view-task-execution.component';


const imageConfig: ImageDefaultConfig = {
  defaultImages: {
    default: 'assets/images/default.jpg',
  },
};
@NgModule({
    declarations: [
        EntryControlComponent,
        StoreComponent,
        AddStoreComponent,
        EditStoreComponent,
        ListStoreComponent,
        AddEmployeesComponent,
        EditEmployeesComponent,
        ListEmployeesComponent,
        AddProvidersComponent,
        EditProvidersComponent,
        ListProvidersComponent,
        AddFacilityComponent,
        EditFacilityComponent,
        ListUsersComponent,
        AddUsersComponent,
        EditUsersComponent,
        EditVisitorComponent,
        AddVisitorComponent,
        ListVisitorComponent,
        RecordsComponent,
        ListGuardComponent,
        AddGuardComponent,
        EditGuardComponent,
        ListDevicesComponent,
        EditDevicesComponent,
        AddDevicesComponent,
        ListRecordsComponent,
        SearchRecordComponent,
        AdminStoreComponent,
        AdminRecordsComponent,
        ListFacilityComponent,
        ListFacilitySupervisorComponent,
        ViewFacilityComponent,
        ListRecorsFacilityComponent,
        ListStoreComponent,
        ListStoresFacilityComponent,
        ListControlsComponent,
        ListRoundsComponent,
        ListTagsComponent,
        EditTagsComponent,
        AddTagsComponent,
        ListPhonesComponent,
        ListScheduledRoundsComponent,
        AddScheduledRoundsComponent,
        EditScheduledRoundsComponent,
        ListRoundsFacilityComponent,
        ListControlsFacilityComponent,
        ListCarsComponent,
        EditCarComponent,
        AddCarComponent,
        DropTagsComponent,
        AdminRoundsComponent,
        AddDriverComponent,
        EditDriverComponent,
        ListDriversComponent,
        ExcelComponent,
            InformationPanelComponent,
        ListTasksFacilityComponent,
        AddTaskChecklistComponent,
        EditTaskChecklistComponent,
        ViewTaskExecutionComponent
    ],
    exports: [
        AddScheduledRoundsComponent
    ],
    imports: [
    CommonModule,
    EntryControlRoutingModule,
    NgbPaginationModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    InputPasswordGenerateComponent,
    WarningInputFormsComponent,
    MatFormFieldModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatInputModule,
    UploadFileModule,
    RepositoryImageModule,
    MatSnackBarModule,
    DndModule,
    TrafficLightComponent,
    SuggestionInputComponent,
    InputTextCompleteComponent,
    ImageDefaultModule.forRoot(imageConfig),
    ToolbarSearchComponent,
    BackButtonComponent,
        EditorHtmlModule,
]
})
export class EntryControlModule { }
